import { Button, Col, Form, Input, Row, Space, theme, Table, message, Popconfirm } from 'antd';
import React, { useEffect, useState } from 'react';
import LoadingBase from '../../components/LoadingBase';
import '../../css/listbook-page.css';
import ModalAddAndEdit from './component/ModalAddAndEdit';
import { getListPositions, positions_create, positions_delete, positions_update } from '../../services/apis';
import { HeaderTableCus, TYPE_MODAL } from '../../constants/constants';
import { PlusOutlined, SearchOutlined } from '@ant-design/icons';

const ListPositionsPage = () => {
    const { token } = theme.useToken();
    const [form] = Form.useForm();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [itemSelected, setItemSelected] = useState();
    const [typeModal, setTypeModal] = useState();
    const [titleModal, setTitleModal] = useState('');
    const columns = [
        {
            title: 'STT',
            key: 'STT',
            width: 80,
            align: 'center',
            render: (text, record, index) => index + 1,
        },
        {
            title: 'Tên chức vụ',
            dataIndex: 'name',
            key: 'name',
            render: (text, record, index) => <a onClick={() => handleEditPosition(record)} style={{paddingLeft: 12}}>{text}</a>,
        },
        {
            title: 'Mô tả',
            dataIndex: 'description',
            key: 'description',
            render: (text, record, index) => <div style={{paddingLeft: 12}}>{text}</div>,
        },
        {
            title: 'Hành động',
            dataIndex: 'action',
            key: 'action',
            width: 120,
            align: 'center',
            render: (text, record) => (
                <Space size="middle">
                    <a onClick={() => handleEditPosition(record)} >Sửa</a>
                    <Popconfirm
                        title="Bạn có chắc chắn muốn xóa?"
                        onConfirm={() => handleDeletePosition(record)}
                        okText="Xóa"
                        cancelText="Hủy"
                        placement="topRight"
                    >
                        <a style={{ color: 'red' }}>Xóa</a>
                    </Popconfirm>
                </Space>
            ),
        },
    ];

    const formStyle = {
        maxWidth: 'none',
        background: 'white',
        borderRadius: token.borderRadiusLG,
        paddingLeft: 0,
        paddingRight: 0,
        marginBottom: 12,
    };
    
    const handleDeletePosition = async (record) => {
        try {
            const params = {
                id: record?.id,
            }
            setLoading(true);
            const res = await positions_delete(params);
            setLoading(false);
            if (res && res.status === 1) {
                message.success('Xoá thành công');
                getDataPositions(true);
            }
            else {
                message.error(res.msg || 'Có lỗi xảy ra, vui lòng thử lại');
            }
        } catch (error) {
            console.log('error', error);
            message.error('Có lỗi xảy ra, vui lòng thử lại');
        }
    }

    const handleEditPosition = (record) => {
        setItemSelected(record);
        setTypeModal(TYPE_MODAL.EDIT);
        setShowModal(true);
        setTitleModal('Sửa chức vụ');
    }
    const handleAddAccount = () => {
        setTypeModal(TYPE_MODAL.ADD);
        setShowModal(true);
        setTitleModal('Thêm chức vụ');
    }
   
    const getDataPositions = async (showLoading) => {
        try {
            const params = {
                keyword: form.getFieldValue('name') ?? '',
            }
            if (showLoading) setLoading(true);
            const res = await getListPositions(params);
            if (showLoading) setLoading(false);
            if (res && res.status === 1) {
                setData([...res?.data]);
            } else {
                message.error(res.msg || 'Có lỗi xảy ra, vui lòng thử lại');
                setData([]);
            }
        } catch (error) {
            setLoading(false);
            console.log('error', error);
            message.error('Có lỗi xảy ra, vui lòng thử lại');
        }
        

    }

    const onFinish = async (dataForm) => {
        getDataPositions(true);
    };
    const callApiAddPosition = async (data) => {
        try {
            const res = await positions_create(data);  
            setLoading(false);
            if (res && res.status === 1) {
                message.success('Thêm mới thành công');
                getDataPositions(true);
            } else {
                message.error(res.message);
            }          
        } catch (error) {
            console.log('error', error);
            setLoading(false);
        }
    }

    const callApiUpdatePosition = async (data) => {
        try {
            setLoading(true);
            const res = await positions_update(data);
            setLoading(false);
            if (res && res.status === 1) {
                message.success('Cập nhật thành công');
                getDataPositions(true);
            } else {
                message.error(res.message);
            }
        } catch (error) {
            console.log('error', error);
            setLoading(false);
        }
    }
    const handleOnSave = async (data) => {
        setShowModal(false);
        if (typeModal === TYPE_MODAL.ADD) {
            callApiAddPosition(data);
        } else {
            callApiUpdatePosition(data);
        }

    }

    useEffect(() => {
        getDataPositions(true)
    }, [])

    return (
        <div className='container-content'>

            <Form form={form} name="advanced_search" style={formStyle} onFinish={onFinish}>
                <Row gutter={24}>
                    <Col span={8}>
                        <Form.Item
                            name={'name'}
                        >
                            <Input placeholder={'Nhập tên'} />
                        </Form.Item>
                    </Col>


                    <Col span={4}>
                        <Space size="small">
                            <Button type="primary" htmlType="submit" icon={<SearchOutlined />}>
                                Tìm kiếm
                            </Button>
                            <Button danger onClick={handleAddAccount} icon={<PlusOutlined />}>
                                Thêm mới
                            </Button>
                        </Space>
                    </Col>
                </Row>
            </Form>
            <Table
                components={HeaderTableCus}
                columns={columns}
                dataSource={data}
                pagination={false}
                rowKey={(record) => record?.id}
                bordered
                rowClassName={() => 'custom-row'}
            />
            <ModalAddAndEdit
                visible={showModal}
                onCancel={() => setShowModal(false)}
                data={itemSelected}
                title={titleModal}
                onSave={handleOnSave}
                type={typeModal}
            />
            <LoadingBase loading={loading} />
        </div>
    )
}
export default React.memo(ListPositionsPage);